module.exports = __webpack_public_path__ + "static/media/site-contenthub.6f1719db.png";